(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/store/redux.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/store/redux.js');
"use strict";

var _svs$arena$data, _svs$arena$data2, _teamsPreloaded$teams;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

const {
  reducer: myTeamsReducer,
  initialState: teamsInitialState
} = svs.arena.store.teams;
const {
  reducer: myTransactionsReducer,
  initialState: transactionsInitialState
} = svs.arena.store.transactions;
const {
  reducer: myWagersReducer,
  initialState: wagesInitialState
} = svs.arena.store.wagers;
const {
  reducer: myGameGuideReducer,
  initialState: gameGuideInitialState
} = svs.arena.store.gameguide;
const reducerObject = {
  teams: myTeamsReducer,
  transactions: myTransactionsReducer,
  wagers: myWagersReducer,
  gameguide: myGameGuideReducer
};

svs.arena.store.createStore = function () {
  let preloaded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return RTK.configureStore({
    reducer: reducerObject,
    preloadedState: preloaded
  });
};

const teamsPreloaded = ((_svs$arena$data = svs.arena.data) === null || _svs$arena$data === void 0 || (_svs$arena$data = _svs$arena$data.preloadedState) === null || _svs$arena$data === void 0 ? void 0 : _svs$arena$data.teams) || {
  teams: []
};
const transactionsPreloaded = ((_svs$arena$data2 = svs.arena.data) === null || _svs$arena$data2 === void 0 || (_svs$arena$data2 = _svs$arena$data2.preloadedState) === null || _svs$arena$data2 === void 0 ? void 0 : _svs$arena$data2.transactions) || {
  transactions: []
};
const addDatesToPreloadedPropertyObjects = inputObject => {
  const newObject = {};
  for (const property in inputObject) {
    if (Object.prototype.hasOwnProperty.call(inputObject, property)) {
      newObject[property] = _objectSpread(_objectSpread({}, inputObject[property]), {}, {
        latestFetch: new Date().getTime()
      });
    }
  }
  return newObject;
};

const totalTeams = {
  teams: [...teamsInitialState.teams, ...teamsPreloaded.teams],
  teamDetails: [...teamsInitialState.teamDetails],
  inviteIds: [...teamsInitialState.inviteIds],
  latestFetch: (_teamsPreloaded$teams = teamsPreloaded.teams) !== null && _teamsPreloaded$teams !== void 0 && _teamsPreloaded$teams.length ? new Date().getTime() : 0,
  error: teamsPreloaded.error
};

const totalTransactions = _objectSpread(_objectSpread({}, transactionsInitialState.transactions), addDatesToPreloadedPropertyObjects(transactionsPreloaded.transactions || {}));

const store = svs.arena.store.createStore({
  teams: totalTeams,
  transactions: totalTransactions,
  wagers: wagesInitialState,
  gameguide: gameGuideInitialState
});
const ArenaReduxProvider = _ref => {
  let {
    children
  } = _ref;
  return React.createElement(ReactRedux.Provider, {
    store: store
  }, children);
};
svs.arena.store.ArenaReduxProvider = ArenaReduxProvider;

 })(window);